<app-loader [isLoader]="loader"></app-loader>
<section class="page-gutter">
    <div class="portlet-container">
        <div class="portlet-head">
            <h2>Content Pool Assets</h2>
            <div class="action">
                <!-- <div class="search-box margin">
                    <img [src]="searchIcon" />
                    <input class="form-control" type="text" placeholder="Search by Content Pool Assets"
                        [(ngModel)]="filter.search" (input)="onSearch($event)" />
                </div> -->
                <!-- <button class="btn default fw-semi margin" (click)="openFilter()">
                    <img [src]="filterIcon" class="filter-icon" alt="filter">
                    Filters
                </button> -->
            </div>
        </div>
        <div class="portlet-body">
            <div class="filter-gutter" [ngClass]="{'opened': toggleFilter}">

            </div>

            @if(contentPoolAsset.length > 0){
            <div class="table-container" [ngClass]="{'active-filter': !toggleFilter}">
                <table class="table primary-table">
                    <thead>
                        <tr>
                            <th>Title</th>
                            <th>Series</th>
                            <th class="release_year">Release Year</th>
                            <th>Casts</th>
                            <th>Topics</th>
                            <th>Imdb</th>
                        </tr>
                    </thead>
                    <tbody>
                        @for(pool of contentPoolAsset; track $index){
                        <tr>
                            <td>{{pool.title}}</td>
                            <td>{{pool.series || '-'}}</td>
                            <td>{{pool.release_year || '-'}}</td>
                            <td>{{convertToCommaSeparated(pool.casts) || '-'}}</td>
                            <td>{{convertToCommaSeparated(pool.topics) || '-'}}</td>
                            <td>{{pool.imdb || '-'}}</td>
                        </tr>
                        }
                    </tbody>
                </table>
            </div>
            }
<!-- 
            @if(contentPoolAsset.length > 0){
            <app-custom-pagination [filter]="filter" (savePage)="fetchUserDataByPage($event)"></app-custom-pagination>
            } -->
            @if(contentPoolAsset.length == 0 && loader == false){
                <app-no-data [noData]="noData"></app-no-data>
            }
        </div>
    </div>
</section>